var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27033 25.0844C6.61663 26.4441 7.18926 28.0774 8.54917 28.7295C9.90927 29.3836 11.5415 28.8107 12.1952 27.451C12.8489 26.0913 12.1514 21.2352 12.1514 21.2352C12.1514 21.2352 7.92422 23.7247 7.27033 25.0844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5596 25.0844C13.9061 26.4441 14.4785 28.0774 15.8386 28.7295C17.1983 29.3836 18.8308 28.8107 19.4845 27.451C20.1382 26.0913 19.4407 21.2352 19.4407 21.2352C19.4407 21.2352 15.2133 23.7247 14.5596 25.0844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.67 18.6483C18.3237 17.2886 17.6262 12.4325 17.6262 12.4325C17.6262 12.4325 13.399 14.922 12.7451 16.2817C12.0914 17.6414 12.664 19.2746 14.0239 19.9267C15.3841 20.5808 17.0163 20.008 17.67 18.6483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9582 19.9267C23.3181 20.5808 24.9504 20.008 25.604 18.6483C26.2577 17.2886 25.5602 12.4325 25.5602 12.4325C25.5602 12.4325 21.333 14.922 20.6792 16.2817C20.0257 17.6414 20.5981 19.2746 21.9582 19.9267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3799 10.5486C25.0338 9.18869 24.3365 4.33317 24.3365 4.33317C24.3365 4.33317 20.1089 6.82148 19.4554 8.18139C18.8017 9.5413 19.374 11.1737 20.7341 11.8274C22.094 12.4801 23.7262 11.9087 24.3799 10.5486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2311 21.2352C26.2311 21.2352 22.0038 23.7247 21.3501 25.0844C20.6964 26.4441 21.269 28.0774 22.6287 28.7295C23.9888 29.3836 25.6211 28.8107 26.275 27.451C26.9286 26.0913 26.2311 21.2352 26.2311 21.2352Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.d5608ef514a5059e657dbfdd03172d84.svg";
export { ForwardRef as ReactComponent };